/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type {
  ChangePasswordResponse,
  GetCurrentUser200,
  LoginResponse,
  LogoutResponse,
} from './model';

export const getGetCurrentUserResponseMock = (
  overrideResponse: Partial<GetCurrentUser200> = {},
): GetCurrentUser200 => ({
  id: faker.string.uuid(),
  name: faker.string.alpha({ length: { min: 10, max: 20 } }),
  email: faker.string.alpha({ length: { min: 10, max: 20 } }),
  tenant: {
    id: faker.string.uuid(),
    code: faker.string.alpha({ length: { min: 10, max: 20 } }),
    name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    local_government_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
  },
  features: {
    [faker.string.alphanumeric(5)]: faker.helpers.arrayElement([
      'visible',
      'disabled',
      'hidden',
    ] as const),
  },
  release_flags: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      type: faker.string.alpha({ length: { min: 10, max: 20 } }),
      is_enabled: faker.datatype.boolean(),
    })),
    undefined,
  ]),
  last_login: faker.helpers.arrayElement([
    faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
    undefined,
  ]),
  is_first_login_completed: faker.datatype.boolean(),
  role: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.helpers.arrayElement(['admin', 'member'] as const), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getLoginResponseMock = (): LoginResponse => ({
  access:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMjItMjItMjItMjItMi0yMjItLTItMjItMjItMjItMjItMjItIiwibmFtZSI6IkFkbWluIn0.example',
  name: 'Admin',
  id: '22222222-2222-2222-2222-222222222222',
  email: 'wisevine_dev_admin@wise-vine.com',
  last_login: '2024-01-01T00:00:00Z',
  tenant_id: '11111111-1111-1111-1111-111111111111',
  features: { settlement_statistics_converter: 'visible', general_chat: 'disabled' },
  is_first_login_completed: true,
});

export const getLogoutResponseMock = (): LogoutResponse => ({ message: 'ログアウトしました' });

export const getChangePasswordResponseMock = (): ChangePasswordResponse => ({
  message: 'パスワードを変更しました',
});

export const getChangeFirstPasswordResponseMock = (): ChangePasswordResponse => ({
  message: 'パスワードを変更しました',
});

export const getGetCurrentUserMockHandler = (
  overrideResponse?:
    | GetCurrentUser200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<GetCurrentUser200> | GetCurrentUser200),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/me',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetCurrentUserResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getLoginMockHandler = (
  overrideResponse?:
    | LoginResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<LoginResponse> | LoginResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/authentication/login',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getLoginResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getLogoutMockHandler = (
  overrideResponse?:
    | LogoutResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<LogoutResponse> | LogoutResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/authentication/logout',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getLogoutResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getChangePasswordMockHandler = (
  overrideResponse?:
    | ChangePasswordResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<ChangePasswordResponse> | ChangePasswordResponse),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/authentication/password',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getChangePasswordResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getChangeFirstPasswordMockHandler = (
  overrideResponse?:
    | ChangePasswordResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<ChangePasswordResponse> | ChangePasswordResponse),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/authentication/password/first',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getChangeFirstPasswordResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getGetCurrentUserMockHandler(),
  getLoginMockHandler(),
  getLogoutMockHandler(),
  getChangePasswordMockHandler(),
  getChangeFirstPasswordMockHandler(),
];
